<bizz-history (backClick)="removeFromViewStack()" [params]="data!"></bizz-history>